import {
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';
import { IAudioTrack } from './IAudioTrack';

import styles from './VbSubtitleMenuButton.module.less';

@Component({
	selector: 'vb-audio-menu',
	template: `
		<ul *ngIf="audioTracks?.length" role="menu" [ngClass]="styles.leftSubMenu">
			<li [ngClass]="styles.subMenuHeading">{{ translations.audio }}</li>
			<li
				*ngFor="let audioTrack of audioTracks"
				role="menuitem">
				<button type="button"
					class="btn-link dropdown-item"
					(click)="onTrackChange(audioTrack);"
					[ngClass]="(vgApi.activeAudioTrack$ | async)?.id === audioTrack.id ? selectedCssClass : ''">
					{{ audioTrack.displayLabel }}
					<span *ngIf="audioTrack.default"> ({{ translations.original }}) </span>
				</button>
			</li>
		</ul>
	`
})
export class VbAudioMenuComponent implements OnChanges {
	@Input() public selectedCssClass: string;
	@Input() public translations: any;
	@Input() public audioTracks: IAudioTrack[];

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.audioTracks && this.audioTracks?.length) {
			this.vgApi.setAudioTrackInPlayer();
		}
	}

	public onTrackChange(track: IAudioTrack): void {
		this.vgApi.setAudioTrackInHlsPlugin?.(track.id);
	}

}
